<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
					{{title}}
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>



			<div class="card card-style">
				<div class="content">
					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check-square color-magenta2-light"></i>
						<span class="color-highlight">عنوان</span>
						<input class="form-control" type="text" v-model="NoticeMassageUser.Title">
					</div>
					<div>
						<div class="input-style input-style-2 has-icon input-required">
							<i class="input-icon fa fa-calendar-times color-magenta2-light"></i>
							<span class="color-highlight" :class="{'input-style-1-active' : NoticeMassageUser.ViewDate!==null}">تاریخ اعلان</span>
							<input type="text" v-model="NoticeMassageUser.ViewDate" id="endDT" />
						</div>
						<date-picker type="date" v-model="NoticeMassageUser.ViewDate" format="jYYYY/jMM/jDD" element="endDT" />
					</div>

					<div class="mb-4">
						<div class="d-flex justify-content-between align-items-center">
							<div class="d-flex align-items-center">
								<i class="fa fa-clock pl-2 color-magenta2-light"></i>
								<label class="mb-0 font-12 font-weight-bold">زمان اعلان</label>
							</div>
							<div class="d-flex flex-column">
								<div class="d-flex justify-content-between align-items-center">
									<label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
									<span class="font-13 font-weight-bold px-3"></span>
									<label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
								</div>
								<div class="ltr">
									<input placeholder="00" class="form-control ltr d-inline-block text-center" @input="() => { if(NoticeMassageUser.ViewTimeHour > 23 || NoticeMassageUser.ViewTimeHour < 0) { NoticeMassageUser.ViewTimeHour = ''}}" style="max-width:60px" type="tel" maxlength="2" max="23" v-model="NoticeMassageUser.ViewTimeHour">
									<span class="font-13 font-weight-bold px-2">:</span>
									<input placeholder="00" @input="() => { if(NoticeMassageUser.ViewTimeMinute > 59 || NoticeMassageUser.ViewTimeMinute < 0) { NoticeMassageUser.ViewTimeMinute = ''}}" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="NoticeMassageUser.ViewTimeMinute">
									<!--<input placeholder="00" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskModel.suggestPersonTimeMinute" @change="saveHeader" @input="v$.taskModel.suggestPersonTimeMinute.$touch()" :class="{invalid:v$.taskModel.suggestPersonTimeMinute.$error}">-->
								</div>
							</div>
						</div>
					</div>
					<!--<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check-square color-magenta2-light"></i>
						<span class="color-highlight">آدرس موبایل</span>
						<input class="form-control ltr text-left" type="text" v-model="NoticeMassageUser.MobileUrl">
					</div>-->
					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check-square color-magenta2-light"></i>
						<span class="color-highlight">آدرس وب</span>
						<input class="form-control ltr text-left" type="text" v-model="NoticeMassageUser.WebUrl">
					</div>
					<div class="input-style input-style-2 has-icon input-required mb-0">
						<i class="input-icon fa fa-check color-magenta2-light"></i>
						<span class="color-highlight ltr">توضیحات</span>
						<textarea v-model="NoticeMassageUser.Description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px"></textarea>
					</div>


					<div class="mb-3">
						<p class="p-2 text-justify pt-0" v-if="isMinVersion">
							در این لیست فقط
							<b class="text-danger">کابران دارای اشتراک</b>
							قابل مشاهده هستند. برای دسترسی به
							<b>لیست تمام کاربران</b>
							به قسمت
							<b class="text-danger">تمدید اشتراک</b>
							مراجعه نمایید.
						</p>
						<div class="scrollableBox400">
							<div class="py-2 borderedListBox" v-for="user in LocalUserListList" :key="user.userId">
								<div class="d-flex align-items-center justify-content-start">
									<input :disabled="user.expired" class="big-checkbox UserSelected" type="checkbox" :value="user.userId" :id="user.userId" :key="user.userId" />
									<div class="w-100 pr-3">
										<div><i class="fa fa-user color-magenta2-light ml-3"></i> <b>{{user.userTitle}}</b></div>
										<div v-if="isMinVersion==false"><i class="fa fa-hashtag color-magenta2-light ml-3"></i>کد واحد سازمانی: <b>{{user.orgJobCode}}</b></div>
										<div v-if="isMinVersion==false"><i class="fa fa-address-card color-magenta2-light ml-3"></i> عنوان واحد سازمانی: <b>{{user.orgJobTitle}}</b></div>
										<div><i class="fa fa-hashtag color-magenta2-light ml-3"></i>کد پست سازمانی: <b>{{user.orgJobCode}}</b></div>
										<div><i class="fa fa-address-card color-magenta2-light ml-3"></i>عنوان پست سازمانی: <b>{{user.orgJobTitle}}</b></div>
									</div>
								</div>

							</div>
						</div>
						<div v-if="Loading" class="d-flex justify-content-center w-100 py-5">
							<div class="spinner-border color-magenta2-dark" role="status"></div>
						</div>
					</div>
					<button :disabled="pageLoading" class="btn btn-xxs btn-full bg-green1-dark rounded-sm font-900 w-100 btn_checkSmsm" @click.prevent="CreateNoticeMassageUser">
						<i class="fa fa-check font-10 ml-2"></i>
						ثبت
					</button>
				</div>
			</div>
			<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
				<div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
					<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	import useVuelidate from '@vuelidate/core'
	import {
		required, between
	} from "@vuelidate/validators";
	import { maska } from 'maska';
	import DatePicker from 'vue3-persian-datetime-picker';
	import VueSimpleAlert from 'vue3-simple-alert';
	export default {
		components: {
			DatePicker
		},
		data() {
			return {
				title: "افزودن اعلان",
				pageLoading: true,
				NoticeMassageUser: {
					NoticeMessageId: 0,
					NoticeMessageUsersJson: null,
					NoticeMessageUsers: [],
					ViewDate: null,
					ViewTime: null,
					mod: false,
					ViewTimeHour: null,
					ViewTimeMinute: null,
					Title: null,
					WebUrl: null,
					MobileUrl: null,
					Description: null,
				}
			}
		},
		methods: {
			CreateNoticeMassageUser() {



				if (this.NoticeMassageUser.Title == null || this.NoticeMassageUser.Title == "") {
					this.showErrorMessage("عنوان را وارد کنید");
					return;
				}
				if (this.NoticeMassageUser.ViewDate == null || this.NoticeMassageUser.ViewDate == "") {
					this.showErrorMessage("تاریخ را وارد کنید");
					return;
				}

				if ((this.NoticeMassageUser.ViewTimeHour == null || this.NoticeMassageUser.ViewTimeHour == "") && (this.NoticeMassageUser.ViewTimeMinute == null || this.NoticeMassageUser.ViewTimeMinute == "")) {
					this.showErrorMessage("زمان اعلان معتبر نیست");
					return;
				}

				if ((this.NoticeMassageUser.ViewTimeHour == null || this.NoticeMassageUser.ViewTimeHour == ""))
					this.NoticeMassageUser.ViewTimeHour = "00";

                if ((this.NoticeMassageUser.ViewTimeMinute == null || this.NoticeMassageUser.ViewTimeMinute == ""))
                    this.NoticeMassageUser.ViewTimeMinute = "00";
				this.NoticeMassageUser.ViewTime = this.NoticeMassageUser.ViewTimeHour + ":" + this.NoticeMassageUser.ViewTimeMinute;
				let checkBox = document.getElementsByClassName("UserSelected");
				let userIds = [];
				let users = [];
				if (checkBox.length > 0) {
					for (var i = 0; i < checkBox.length; i++) {
						if (checkBox[i].checked) {
							userIds.push(checkBox[i].value);
						}
						let user = {
							Selected: userIds.includes(checkBox[i].value),
							UserId: checkBox[i].value,
						};
						users.push(user);
					}
				}
				if (userIds.length == null || userIds.length <= 0) {
					this.showErrorMessage("هیچ کاربری انتخاب نشده است");
					return;
				}
				this.NoticeMassageUser.NoticeMessageUsersJson = userIds.join(",");
				this.NoticeMassageUser.NoticeMessageUsers = users;
				this.pageLoading = true;
				this.$http.post("NoticeMassageUser/Create", this.NoticeMassageUser)
					.then(data => {
						this.pageLoading = false;
						var res = data.data;

						if (res.isSuccess) {
							this.showSuccessMessage(res.message);
							this.goBack();
						} else {
							this.showErrorMessage(res.message);
						}
					});

			}

			, GetNoticeMassageUserList() {
				this.pageLoading = true;
				this.$http
					.get("NoticeMassageUser/NotificationMessageUser?id=0")
					.then((data) => {
						var res = data.data;
						this.NoticeMassageUser.NoticeMessageUsers = res;
						this.pageLoading = false;
					});

			},
		},
		computed: {
			LocalUserListList() {
				return this.NoticeMassageUser.NoticeMessageUsers;
			},
		},
		created() {
			this.$store.dispatch("CheckUserSMS");
			this.GetNoticeMassageUserList();

		},
		mounted() {
			this.pageLoading = false;
		},
		validations: {
			NoticeMassageUser: {
				ViewDate: {
					required,
				},
				ViewTime: {
					required
				},
				Title: {
					required
				}
			}
		},
		directives: { maska },
	}
</script>